import { render } from "./ReporteCreditoPage.vue?vue&type=template&id=37f2d984&scoped=true&ts=true"
import script from "./ReporteCreditoPage.vue?vue&type=script&lang=ts"
export * from "./ReporteCreditoPage.vue?vue&type=script&lang=ts"

import "./ReporteCreditoPage.vue?vue&type=style&index=0&id=37f2d984&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f2d984"]])

export default __exports__